import DriverListModal from './driverList';
import ISAEditModal from './isaEdit';
import CTNEditModal from './ctnEdit';
import ShippingStatusEditModal from './shippingStatusEdit';
import Notes from './Notes';
import LocationChange from './LocationChange';
import InboundDateChange from './InboundDateChange';
import BatchesModal from './BatchesModal';
import DeliveryTimeChange from './DeliveryTimeChange';
import PickupTimeChange from './PickupTimeChange';
import ExcelUploadOption from './ExcelUploadOption';

const salesOrderModals = {
  DriverListModal,
  ISAEditModal,
  CTNEditModal,
  ShippingStatusEditModal,
  Notes,
  LocationChange,
  InboundDateChange,
  BatchesModal,
  DeliveryTimeChange,
  PickupTimeChange,
  ExcelUploadOption,
}

export default salesOrderModals;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/index.jsx